import React from 'react';
import { motion } from 'framer-motion';
import './QuizSection.css';

const QuizSection = () => {
  const quizFeatures = [
    {
      icon: '📝',
      title: 'Topic Wise Quizzes',
      desc: 'Finish a topic and immediately test your depth with targeted questions.'
    },
    {
      icon: '⚡',
      title: '1000+ Questions',
      desc: 'Massive question bank covering every edge case and concept.'
    },
    {
      icon: '🏆',
      title: 'Leaderboards',
      desc: 'Compete with peers and track your ranking in real-time.'
    }
  ];

  return (
    <section className="ucp-section quiz-mastery-section">
      <div className="quiz-container">
        <div className="quiz-content">
          <motion.div 
            className="quiz-visual"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            {/* Phone Mockup Wrapper */}
            <div className="phone-mockup">
              <div className="phone-screen">
                <div className="phone-header">
                  <div className="notch"></div>
                  <div className="status-bar">
                    <span>9:41</span>
                    <div className="status-icons">📶 🔋</div>
                  </div>
                </div>

                <div className="app-content">
                  <div className="workflow-header">
                    <span className="gold-text">EVALUATION FLOW</span>
                    <h3>Your Journey</h3>
                  </div>

                  <div className="workflow-steps">
                    <div className="wf-step completed">
                      <div className="step-check">✓</div>
                      <div className="step-text">
                        <span>STEP 01</span>
                        <strong>Topic Completed</strong>
                      </div>
                    </div>
                    
                    <div className="wf-connector"></div>

                    <div className="wf-step active">
                      <div className="step-icon">🎯</div>
                      <div className="step-text">
                        <span>STEP 02</span>
                        <strong>Solve 1000+ Quizzes</strong>
                      </div>
                    </div>

                    <div className="wf-connector dotted"></div>

                    <div className="wf-step pending">
                      <div className="step-icon">💎</div>
                      <div className="step-text">
                        <span>STEP 03</span>
                        <strong>Master the Concept</strong>
                      </div>
                    </div>
                  </div>

                  {/* Floating Quiz Stats inside Phone */}
                  <div className="quiz-card-mobile">
                    <div className="q-card-header">
                      <span>Quiz #24: OOPS</span>
                      <div className="q-timer">00:45</div>
                    </div>
                    <div className="q-card-question">
                      Output of this snippet?
                    </div>
                    <div className="q-options">
                      <div className="option">Error</div>
                      <div className="option correct">Exception</div>
                      <div className="option">0</div>
                    </div>
                    <button className="q-submit">SUBMIT ANSWER</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="visual-glow"></div>
          </motion.div>

          <motion.div 
            className="quiz-info"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="quiz-badge">CONTINUOUS EVALUATION</span>
            <h2>Topic Completed? <br /><span className="blue-text">Now Solve the Quiz</span></h2>
            <p>
              Mastery comes through practice. Our platform provides an exhaustive bank of 
              <strong> 1000+ interactive quizzes</strong> that trigger the moment you finish a topic.
            </p>
            
            <div className="quiz-features-grid">
              {quizFeatures.map((feature, i) => (
                <div key={i} className="q-feature-item">
                  <div className="q-f-icon">{feature.icon}</div>
                  <div className="q-f-text">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default QuizSection;
